"use client";

import type { FC } from "react";
import { useEffect } from "react";

const ControlNavFooter: FC = () => {
  useEffect(() => {
    const els = ["nav-bar", "tab-navigation", "footer-content"];
    els.forEach((id) => {
      const elements = document.querySelectorAll(`#${id}`);
      if (elements.length > 1) {
        elements.forEach((el, index) => {
          if (index > 0) {
            // (el as HTMLElement).style.display = "none"; // Hide duplicate elements
            (el as HTMLElement).remove();
          }
        });
      }
    });
  }, []);

  return null;
};

export default ControlNavFooter;
